
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4703_87)"}},[_c('path',{attrs:{"d":"M10 6.111a3.852 3.852 0 00-1.085.174c.163.286.25.608.252.937a1.944 1.944 0 01-1.945 1.945 1.924 1.924 0 01-.937-.252A3.879 3.879 0 1010 6.111zm9.88 3.382c-1.884-3.674-5.612-6.16-9.88-6.16-4.268 0-7.997 2.488-9.88 6.16a1.123 1.123 0 000 1.014c1.884 3.674 5.612 6.16 9.88 6.16 4.268 0 7.997-2.488 9.88-6.16a1.124 1.124 0 000-1.014zM10 15c-3.425 0-6.566-1.91-8.261-5C3.434 6.91 6.574 5 10 5c3.426 0 6.566 1.91 8.262 5-1.696 3.09-4.836 5-8.262 5z","fill":"#49454F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4703_87"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    